import { __module as isBuffer } from "./auth-service-tools1202.js";
import { _ as _root } from "./auth-service-tools993.js";
import { s as stubFalse_1 } from "./auth-service-tools1203.js";
isBuffer.exports;

(function (module, exports) {
  var root = _root,
      stubFalse = stubFalse_1;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer = moduleExports ? root.Buffer : void 0;
  var nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0;
  var isBuffer2 = nativeIsBuffer || stubFalse;
  module.exports = isBuffer2;
})(isBuffer, isBuffer.exports);

var isBufferExports = isBuffer.exports;
export { isBufferExports as i };